module.exports = __webpack_public_path__ + "img/title2.b628ddcd.png";